import { useState } from 'react'
import type { WeddingSettings } from '@shared/settings'
import { Seccion, cx, tieneTexto } from './comunes'

/* ===========================================================================
   Trivia — un juego, no un examen.
   Se acierta o no se acierta y se sigue leyendo la invitación.
   =========================================================================== */

type Trivia = WeddingSettings['trivia']

function opcionesValidas(trivia: Trivia): string[] {
  return trivia.options.filter((o) => tieneTexto(o))
}

export function hayTrivia(trivia: Trivia): boolean {
  return tieneTexto(trivia.question) && opcionesValidas(trivia).length >= 2
}

export default function TriviaSeccion({ trivia }: { trivia: Trivia }) {
  const [elegida, setElegida] = useState<number | null>(null)
  const opciones = trivia.options

  // El índice correcto se refiere al array original, no al filtrado.
  const correcta = trivia.answerIndex
  const acerto = elegida !== null && elegida === correcta
  const respuesta = opciones[correcta] ?? ''

  return (
    <Seccion id="trivia" eyebrow="Un juego" titulo="¿Cuánto nos conoces?">
      <p className="max-w-xl text-lg leading-relaxed text-tinta">{trivia.question}</p>

      <ul className="mt-6 grid max-w-xl gap-3 sm:grid-cols-2 lg:max-w-none">
        {opciones.map((opcion, i) => {
          if (!tieneTexto(opcion)) return null
          const esta = elegida === i
          const revelada = elegida !== null && i === correcta

          return (
            <li key={`${i}-${opcion}`}>
              <button
                type="button"
                onClick={() => setElegida(i)}
                aria-pressed={esta}
                className={cx(
                  'w-full min-h-[46px] border px-4 py-3 text-left text-sm transition-colors',
                  revelada
                    ? 'border-verdemar bg-verdemar/10 text-tinta'
                    : esta
                      ? 'border-ladrillo bg-ladrillo/8 text-tinta'
                      : 'border-palo text-tinta hover:bg-palo/40',
                )}
              >
                {opcion}
              </button>
            </li>
          )
        })}
      </ul>

      <p aria-live="polite" className="mt-6 min-h-6 text-sm">
        {elegida === null ? (
          ''
        ) : acerto ? (
          <span className="text-verdemar">Correcto. Nos conoces bien.</span>
        ) : (
          <span className="text-tinta/85">Casi. La respuesta es: {respuesta}</span>
        )}
      </p>
    </Seccion>
  )
}
